import type { AxiosRequestConfig } from "axios";

declare module "axios" {
  export interface AxiosRequestConfig {
    /** Si vrai, n'affiche pas l'indicateur global (sablier plein écran). */
    skipBusyIndicator?: boolean;
  }
}

/** Config Axios sans sablier global — chargement local dans le composant. */
export const u2000SkipBusyIndicatorConfig: AxiosRequestConfig = {
  skipBusyIndicator: true,
};
